import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=aa14e38a&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=aa14e38a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa14e38a",
  null
  
)

export default component.exports